<div class="wrapper bottom-padding">
  <div class="heading limit-width-on-desktop-float" *ngIf="this.quoteType !== QuoteType.MyProfile">
    <h2 class="h2-bold">{{ header }}</h2>
    <p>{{ subHeader }}</p>
  </div>
  <div
    class="card limit-width-on-desktop-float"
    *ngFor="let group of questionGroup"
    [ngClass]="{ 'profile-card': this.quoteType === QuoteType.MyProfile }"
  >
    <div class="section-heading" *ngIf="this.quoteType !== QuoteType.MyProfile">
      <h3>{{ group.headings }}</h3>
    </div>
    <div *ngFor="let questionAnswers of group.answeredQuestions">
      <div [ngSwitch]="questionAnswers?.question_type">
        <div *ngSwitchCase="QuestionType.vehicleSearch">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <div class="questions-wrapper">
              <label>Vehicle type</label>
              <p>
                <b>{{ vehicleType }}</b>
              </p>
            </div>
            <div class="questions-wrapper">
              <label>Year of registration</label>
              <p>
                <b>{{ vehicleYearReg }}</b>
              </p>
            </div>
            <div class="questions-wrapper">
              <label>Year of manufacture</label>
              <p>
                <b>{{ vehicleYear }}</b>
              </p>
            </div>
            <div class="questions-wrapper">
              <label>Make</label>
              <p>
                <b>{{ vehicleMake }}</b>
              </p>
            </div>
            <div class="questions-wrapper">
              <label>Model</label>
              <p>
                <b>{{ vehicleModel }}</b>
              </p>
            </div>
          </ng-container>
        </div>
        <div *ngSwitchCase="QuestionType.address">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <ng-container *ngFor="let answer of questionAnswers.underwriting_answers">
              <div class="questions-wrapper address-summary" *ngIf="answer.address_object as addressObject">
                <label>{{ questionAnswers.wording_for_summary }}</label>
                <ion-item mode="ios" class="field-item" lines="none">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.address_type | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Address type</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.province | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Province</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.suburb | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Suburb</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.postal_code | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Postal code</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.street_name | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Street name</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.street_number | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Street number</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none" *ngIf="addressObject.address_type === 'estate'">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.estate | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Estate</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none" *ngIf="addressObject.address_type === 'sectional'">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.sectional_title | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Sectional title</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
                <ion-item mode="ios" class="field-item" lines="none" *ngIf="addressObject.address_type === 'estate' || addressObject.address_type === 'sectional'">
                  <ion-input labelPlacement="floating" readonly="true" [ngModel]="addressObject.unit_number | uppercase">
                    <div slot="label">
                      <ion-text class="standard-input-label">Unit number</ion-text>
                    </div>
                  </ion-input>
                </ion-item>
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div *ngSwitchCase="QuestionType.boolean">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <div class="questions-wrapper" *ngFor="let answer of questionAnswers.underwriting_answers"
              [ngClass]="{ 'empty-answer': answer.object_answer === null || answer.object_answer === undefined }">
              <label *ngIf="questionAnswers.wording_for_summary">{{ questionAnswers.wording_for_summary }}</label>
              <label *ngIf="!questionAnswers.wording_for_summary">{{ answer.place_holder }}</label>
              <p *ngIf="answer.object_answer === true"><b>Yes</b></p>
              <p *ngIf="answer.object_answer === false"><b>No</b></p>
              <p class="empty-answer-message" *ngIf="answer.object_answer === null || answer.object_answer === undefined">Please
                select Yes or No</p>
            </div>
          </ng-container>
        </div>
       <div *ngSwitchCase="'LIST'">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <div class="questions-wrapper">
              <label>{{ questionAnswers.wording_for_summary }}</label>
              @for (answer of questionAnswers.underwriting_answers[0].object_answer; track $index) {
                {{answer.length}}
                @if (answer.length === 0) {
                  <p><b>None</b></p>
                } @else {
                  <div>
                    <p><b>{{ answer.reason ? answer.reason : answer.description }}</b></p>
                    @if (answer.date_full) {
                      <p><b style="font-size: 12px;">{{ setDateFormat(answer?.date_full) }}</b></p>
                    }
                  </div>
                }
              }
            </div>
          </ng-container>
        </div>
        <div *ngSwitchCase="QuestionType.multiSelect">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <h5 *ngIf="questionAnswers.wording_for_summary">{{ questionAnswers.wording_for_summary }}</h5>
            <div class="questions-wrapper mt-4" *ngFor="let answer of questionAnswers.underwriting_answers">
              <label *ngIf="!answer.place_holder">{{ questionAnswers.wording_for_summary }}</label>
              <label *ngIf="answer.place_holder">{{ answer.place_holder }}</label>
              <p *ngIf="answer.object_answer === true"><b>Yes</b></p>
              <p *ngIf="answer.object_answer === false"><b>No</b></p>
            </div>
          </ng-container>
        </div>
        <div *ngSwitchCase="QuestionType.dateTime">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <div class="questions-wrapper" *ngFor="let answer of questionAnswers.underwriting_answers">
              <label>{{ questionAnswers.wording_for_summary }}</label>
              <p>
                <b>{{ answer.object_answer }}</b>
              </p>
            </div>
          </ng-container>
        </div>
        <div *ngSwitchCase="QuestionType.date">
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <div class="questions-wrapper" *ngFor="let answer of questionAnswers.underwriting_answers">
              <label>{{ questionAnswers.wording_for_summary }}</label>
              <p>
                <b>{{ this.dateService.formateDate(answer.object_answer) }}</b>
              </p>
            </div>
          </ng-container>
        </div>
        <div *ngSwitchDefault>
          <ng-container *ngIf="questionAnswers.view_on_summary">
            <div
              class="questions-wrapper"
              *ngFor="let answer of questionAnswers.underwriting_answers"
              [ngClass]="{ 'empty-answer': isEmptyAnswer(answer) }"
            >
              <label *ngIf="questionAnswers.wording_for_summary">{{ questionAnswers.wording_for_summary }}</label>
              <label *ngIf="!questionAnswers.wording_for_summary">{{ answer.place_holder }}</label>
              <p>
                <b>{{ answer.object_answer }}</b>
              </p>
              <p class="empty-answer-message" *ngIf="isEmptyAnswer(answer)">This field needs to be filled in</p>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="button-row">
      <ion-button *ngIf="quoteType !== QuoteType.ViewAssetOnly" mode="ios" class="secondary-button" (click)="edit(group.headings)"
        >Edit&nbsp;<i>{{ group.headings }}</i></ion-button
      >
    </div>
  </div>
</div>
<div class="footer-button-wrapper" *ngIf="quoteType !== QuoteType.MyProfile">
  <div class="fade"></div>
  <div class="footer-button-background">
    <ion-button mode="ios" class="footer-button limit-width-desktop-on-button" expand="block" (click)="confirm()"> Looks good! </ion-button>
  </div>
</div>

<small-popup *ngIf="showUpdatePopup" [header]="popUpHeading" [message]="popupMessage">
  <ion-button mode="ios" class="primary-button" (click)="showIntercom()">Contact us </ion-button>
  <ion-button mode="ios" class="secondary-button" (click)="closePopup()">Cancel </ion-button>
</small-popup>

<!-- TODO ALL OTHER POPUPS SHOULD BE REPLACED BY THIS GENERIC POPUP -->
<popup-dialog id="quote.summary.not.editible.component" *ngIf="sharedConfig.popupDialogShow"></popup-dialog>
